import Vue from 'vue'
import Router from 'vue-router'

export const Layout = () => import('../views/Home.vue');

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    redirect: '/home',
    meta: {hidden: true},
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue'),
    meta: {hidden: true}
  },
  {
    path: '/errorPage',
    name: '404',
    meta: {hidden: true},
    component: () => import('../views/ErrorPage.vue'),
  },
  {
    path: '/home',
    name: 'home',
    redirect: '/dashboard',
    component: Layout,
    meta: {title: '首页', hidden: false, icon: 'dashboard',},
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/dashboard/index'),
        meta: {title: '控制台', hidden: false, icon: 'el-icon-house',},
      }
    ]
  },
]

// 动态路由，根据权限来判断
export const dynamicRoutes = [
  {
    path: '/institutionManagement',
    name: 'institutionManagement',
    component: Layout,
    meta: {title: '机构管理', hidden: false, icon: 'el-icon-office-building', perms: ""},
    children: [
      {
        path: '/institution',
        name: 'institution',
        meta: {title: '机构管理', hidden: false, icon: 'el-icon-office-building', perms: "institution:list"},
        component: () => import('../views/institution/index'),
      },
    ]
  },
  {
    path: '/featureManagement',
    name: 'featureManagement',
    component: Layout,
    meta: {title: '功能管理', hidden: false, icon: 'el-icon-document-copy', perms: ""},
    children: [
      {
        path: '/sysFeature',
        name: 'feature',
        meta: {title: '功能', hidden: false, icon: 'el-icon-document-remove', perms: "sysFeature:list"},
        component: () => import('../views/sysFeature/index'),
      },
      {
        path: '/sysFeatureGroup',
        name: 'sysFeatureGroup',
        meta: {title: '功能组', hidden: false, icon: 'el-icon-document', perms: "sysFeatureGroup:list"},
        component: () => import('../views/sysFeatureGroup/index'),
      },
    ]
  },
  {
    path: '/regionManagement',
    name: 'regionManagement',
    component: Layout,
    meta: {title: '区域管理', hidden: false, icon: 'el-icon-s-grid', perms: ""},
    children: [
      {
        path: '/area',
        name: 'region',
        meta: {title: '区域管理', hidden: false, icon: 'el-icon-s-grid', perms: "area:view"},
        component: () => import('../views/area/index'),
      },
    ]
  },
  {
    path: '/uavManagement',
    name: 'uavManagement',
    component: Layout,
    meta: {title: '无人机管理', hidden: false, icon: 'el-icon-set-up', perms: ""},
    children: [
      {
        path: '/uav',
        name: 'uav',
        meta: {title: '无人机管理', hidden: false, icon: 'el-icon-set-up', perms: "uav:list"},
        component: () => import('../views/uav/index'),
      },
    ]
  },

  {
    path: '/uavUserManagement',
    name: 'uavUserManagement',
    redirect: '/uavUser',
    component: Layout,
    meta: {title: '爱好者管理', hidden: false, icon: 'el-icon-user', perms: ""},
    children: [
      {
        path: '/uavUser',
        name: 'uavUser',
        meta: {title: '爱好者管理', hidden: false, icon: 'el-icon-user', perms: "uavUser:list"},
        component: () => import('../views/uavUser/index'),
      },
    ]
  },
  {
    path: '/taskManagement',
    name: 'taskManagement',
    meta: {title: '任务管理', hidden: false, icon: 'el-icon-document', perms: ""},
    component: Layout,
    children: [{
      path: '/task',
      name: 'task',
      component: () => import ('../views/task/index.vue'),
      meta: {title: '任务管理', hidden: false, icon: 'el-icon-document', perms: "task:detail"}
    }, {
      path: '/taskDetail',
      name: 'taskDetail',
      component: () => import ('../views/task/detail'),
      meta: {title: '任务详情', hidden: true, icon: 'el-icon-document', perms: ""}
    }],
  },
  {
    path: '/alarmManagement',
    name: 'alarmManagement',
    redirect: '/alarm',
    component: Layout,
    meta: {title: '举报管理', hidden: false, icon: 'el-icon-message-solid', perms: ""},
    children: [
      {
        path: '/alarm',
        name: '举报管理',
        meta: {title: '举报管理', hidden: false, icon: 'el-icon-message-solid', perms: "report:list"},
        component: () => import('../views/alarm/index'),
      },
    ]
  },
  {
    path: '/verificationManagement',
    name: 'verificationManagement',
    redirect: '/alarm',
    component: Layout,
    meta: {title: '证件核验', hidden: false, icon: 'el-icon-postcard', perms: ""},
    children: [
      {
        path: '/verification',
        name: '证件核验',
        meta: {title: '证件核验', hidden: false, icon: 'el-icon-postcard', perms: "verification:list"},
        component: () => import('../views/verification/index'),
      },
    ]
  },
  {
    path: '/noticeManagement',
    name: 'noticeManagement',
    redirect: '/area',
    component: Layout,
    meta: {title: '通知管理', hidden: false, icon: 'el-icon-message', perms: ""},
    children: [
      {
        path: '/notice',
        name: 'notice',
        meta: {title: '通知管理', hidden: false, icon: 'el-icon-message', perms: "notice:list"},
        component: () => import('../views/notice/index'),
      },
    ]
  },
  {
    path: '/newsManagement',
    name: 'newsManagement',
    redirect: '/news',
    component: Layout,
    meta: {title: '资讯管理', hidden: false, icon: 'el-icon-news', perms: ""},
    children: [
      {
        path: '/news',
        name: 'news',
        meta: {title: '资讯管理', hidden: false, icon: 'el-icon-news', perms: "notice:news"},
        component: () => import('../views/news/index'),
      },
    ]
  },
  {
    path: '/organizationManagement',
    name: 'organizationManagement',
    component: Layout,
    meta: {title: '组织架构', hidden: false, icon: 'el-icon-s-management', perms: ""},
    children: [
      {
        path: '/user',
        name: 'user',
        meta: {title: '用户管理', hidden: false, icon: 'el-icon-user-solid', perms: "user:orgSearch"},
        component: () => import('../views/user/index'),
      },
      {
        path: '/organization',
        name: 'organization',
        meta: {title: '组织管理', hidden: false, icon: 'el-icon-s-management', perms: "organization:treeList"},
        component: () => import('../views/organization/index'),
      },
      {
        path: '/role',
        name: 'role',
        meta: {title: '角色管理', hidden: false, icon: 'el-icon-s-custom', perms: "role:list"},
        component: () => import('../views/role/index'),
      },
      {
        path: '/template',
        name: 'template',
        meta: {title: '模板管理', hidden: false, icon: 'el-icon-tickets', perms: "sys:remindTemplate:list"},
        component: () => import('../views/template/index'),
      },
    ]
  },
  {
    path: '/systemSetting',
    name: 'systemSetting',
    component: Layout,
    meta: {title: '系统设置', hidden: false, icon: 'el-icon-user-solid', perms: ""},
    children: [
      {
        path: '/personCenter',
        name: 'personCenter',
        meta: {title: '个人中心', hidden: false, icon: 'el-icon-user-solid', perms: ""},
        component: () => import('../views/personCenter/index'),
      },
      {
        path: '/log',
        name: 'log',
        meta: {title: '操作日志', hidden: false, icon: 'el-icon-tickets', perms: "operationLog:list"},
        component: () => import('../views/log/index'),
      },
      {
        path: '/menu',
        name: 'menu',
        meta: {title: '菜单管理', hidden: true, icon: 'el-icon-menu', perms: "role:roleMenu"},
        component: () => import('../views/menu/index'),
      },
    ]
  },
  {
    path: '*',
    redirect: '/errorPage',
    name: 'notFound',
    meta: {hidden: true}
  }
]

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const createRouter = () => new Router({
  mode: 'hash',
  scrollBehavior: () => ({y: 0}),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js